import { EGroupedItemsType } from '~/src/services/properties';

export const columnWithStylesConfig = {
    label: {
        label: '',
        type: EGroupedItemsType.Title,
    },
    properties: {
        name: 'properties',
        items: {
            customStyles: {
                name: 'customStyles',
                label: 'Расширенные CSS-стили:',
                type: EGroupedItemsType.Text,
                order: 1,
                withBreakpoints: true,
            },
            sortOrder: {
                name: 'sortOrder',
                label: 'Сортировка',
                type: EGroupedItemsType.String,
                order: 2,
            },
            removeElement: {
                name: 'removeElement',
                label: 'Удалить колонку',
                type: EGroupedItemsType.ButtonRemove,
                order: 3,
            },
        },
    },
};
